import { useWidgetStore } from '@features/common/store/AppStore';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { LadderStore } from './context/LadderStore';

export interface LadderTabOptionsProps {
  widgetId: string;
  tabIndex: number;
}

export const LadderTabOptions = (props: LadderTabOptionsProps) => {
  const { widgetId, tabIndex } = props;

  const store = useWidgetStore<LadderStore>(widgetId);

  const { tabs, updateTabConfig } = store;

  const tabData = tabs[tabIndex];

  if (!tabData) {
    return <></>;
  }

  const { showAllTicks, allowFillOrKill } = tabData.config;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        padding: '4px 0',
        gap: '4px',
      }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={allowFillOrKill || false}
            onClick={() => {
              updateTabConfig(tabIndex, { allowFillOrKill: !allowFillOrKill });
            }}
          />
        }
        label={'Market orders:'}
        labelPlacement="start"
        sx={{ paddingLeft: 0, marginLeft: '4px' }}
      />

      <FormControlLabel
        control={
          <Switch
            checked={showAllTicks || false}
            onClick={() => {
              updateTabConfig(tabIndex, { showAllTicks: !showAllTicks });
            }}
          />
        }
        label={'All ticks:'}
        labelPlacement="start"
        sx={{ paddingLeft: 0, marginLeft: '4px' }}
      />
    </Box>
  );
};
